var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MapTab',{key:"mapTabPub",attrs:{"target":"pub"}})
}
var staticRenderFns = []

export { render, staticRenderFns }